EMMET
<span *ngIf="environment.environmentLabel" class="environment-name">
  {{ environment.environmentLabel }}
</span>
-
<a [href]="'https://github.com/LEGO/EMMET/commit/' + environment.version" target="_blank">
  {{ environment.version }}
</a>
- 07.04.01 Mould Technology R&D
